export function articlePageFetchingStatus(state, articleId) {
    const currentPage = state.page.currentPage;
    const loadingPage = state.page.loadingPage;
    if (currentPage &&
        currentPage.pageType === 'article' &&
        currentPage.articleId === articleId) {
        return currentPage.status;
    }
    if (loadingPage &&
        loadingPage.pageType === 'article' &&
        loadingPage.articleId === articleId) {
        return 'is-fetching';
    }
    return 'not-started';
}
export function categoryPageFetchingStatus(state, categoryId) {
    const currentPage = state.page.currentPage;
    const loadingPage = state.page.loadingPage;
    if (currentPage &&
        currentPage.pageType === 'category' &&
        currentPage.categoryId === categoryId) {
        return currentPage.status;
    }
    if (loadingPage &&
        loadingPage.pageType === 'category' &&
        loadingPage.categoryId === categoryId) {
        return 'is-fetching';
    }
    return 'not-started';
}
export function searchPageFetchingStatus(state, _searchTerm) {
    const currentPage = state.page.currentPage;
    const loadingPage = state.page.loadingPage;
    if (currentPage &&
        currentPage.pageType === 'search' &&
        currentPage.searchTerm === _searchTerm) {
        return currentPage.status;
    }
    if (loadingPage &&
        loadingPage.pageType === 'search' &&
        loadingPage.searchTerm === _searchTerm) {
        return 'is-fetching';
    }
    return 'not-started';
}
export function homePageFetchingStatus(state) {
    const currentPage = state.page.currentPage;
    const loadingPage = state.page.loadingPage;
    if (currentPage && currentPage.pageType === 'home') {
        return currentPage.status;
    }
    if (loadingPage && loadingPage.pageType === 'home') {
        return 'is-fetching';
    }
    return 'not-started';
}
export function getArticlePageData(state, articleId) {
    const currentPage = state.page.currentPage;
    if (currentPage &&
        currentPage.pageType === 'article' &&
        currentPage.articleId === articleId) {
        return currentPage.data;
    }
    return null;
}
export function getCategoryPageData(state, categoryId) {
    const currentPage = state.page.currentPage;
    if (currentPage &&
        currentPage.pageType === 'category' &&
        currentPage.categoryId === categoryId) {
        return currentPage.data;
    }
    return null;
}
export function getHomePageData(state) {
    const currentPage = state.page.currentPage;
    if (currentPage && currentPage.pageType === 'home') {
        return currentPage.data;
    }
    return null;
}
export function searchFetchingStatus(state, query, page) {
    // Do we have it already?
    if (state.search.searchedTerm === query &&
        state.search.currentPage === page) {
        return 'has-fetched';
    }
    if (state.search.searchedTerm === query &&
        state.search.currentPage &&
        state.search.currentPage - 1 === page &&
        state.search.isFetching) {
        return 'is-fetching';
    }
    return 'not-started';
}
export function searchTerm(state) {
    if (!state.page.currentPage)
        return '';
    if (state.page.currentPage.pageType !== 'search')
        return '';
    return state.page.currentPage.searchTerm;
}
//# sourceMappingURL=index.js.map